import MinusIcon from '@/components/Icons/MinusIcon';
import PlusIcon from '@/components/Icons/PlusIcon';
import { Faq } from '@/lib/interfaces';
import { useState } from 'react';

export default function FAQExpandableRow({ question, answer }: Faq) {
  const [open, setOpen] = useState(false);
  return (
    <div
      onClick={() => setOpen(!open)}
      className="flex flex-col border-b cursor-pointer border-grey-300"
    >
      <div className="flex items-center justify-between h-8.0">
        <h4 className="w-3/4 uppercase text-body lgt:text-mobile-l">
          {question}
        </h4>

        <div className="flex-shrink-0">
          {open ? <MinusIcon /> : <PlusIcon />}
        </div>
      </div>

      {open && <p className="mb-1.6 text-body">{answer}</p>}
    </div>
  );
}
